import { getAnalyticsTracker } from "analytics";
import FileSaver from "file-saver";
import JSZip from "jszip";
import type React from "react";
import { useTranslation } from "react-i18next";
import { fileNameBuilder } from "utils/fileNameBuilder";
import type { DownloadButtonProps } from "./DownloadButton.model";
import { StyledDownloadButton, StyledIcon } from "./DownloadButton.styled";

export const DownloadButton: React.FC<DownloadButtonProps> = ({ dataCy, documents }) => {
  const { t } = useTranslation("material");

  const downloadZipFile = (files: Array<{ title: string; content: Blob }>) => {
    const zip = new JSZip();
    for (const file of files) {
      zip.file(file.title, file.content);
    }

    zip.generateAsync({ type: "blob" }).then((file) => {
      FileSaver.saveAs(file, `${t("additionals.allMaterial", "all-material")}.zip`);
      getAnalyticsTracker()?.fileDownloaded({
        url: "local-download",
        name: "all-material.zip",
        id: "all-material.zip",
        source: "edify",
        extension: "zip",
      });
    });
  };

  const downloadFiles = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    const getFiles = documents.map(({ content, title }) =>
      fetch(content.content.href)
        .then((res) => res.blob())
        .then((fileContent) => ({
          title: fileNameBuilder(title, fileContent.type),
          content: fileContent,
        })),
    );

    Promise.all(getFiles)
      .then((files) => downloadZipFile(files))
      .catch(() => {
        // TODO: Add toast notification
      });
  };

  return (
    <StyledDownloadButton
      aria-hidden="true"
      data-cy={dataCy}
      data-mdat="element-clicked"
      data-mdat-item-id="extra-material-download-all-button"
      data-mdat-module="extra-material"
      onClick={(e) => downloadFiles(e)}
    >
      <StyledIcon className="icon-download" />
      {t("additionals.downloadMaterial", "Download all material")}
    </StyledDownloadButton>
  );
};
